import { CORE_SIZE__SINGLEMODE, TERMINATION_TYPE__FLAT_CONNECTOR } from '@shared/constants/constants';

export function doesNotSupportOrderingReferenceByChannel(coreSize, terminationTypeEndA) {
    if (!coreSize || !terminationTypeEndA) {
        return true;
    }

    return coreSize !== CORE_SIZE__SINGLEMODE &&
           terminationTypeEndA !== TERMINATION_TYPE__FLAT_CONNECTOR;
}